<script>
export default {
  props: ['stableData'],
  data () {
    return {
      posSelectOptions: [{
        value: 1,
        label: 'Ua'
      }, {
        value: 2,
        label: 'Ub'
      }, {
        value: 3,
        label: 'Uc'
      }, {
        value: 4,
        label: 'Uab'
      }, {
        value: 5,
        label: 'Ubc'
      }, {
        value: 6,
        label: 'Uca'
      }, {
        value: 7,
        label: 'Ia'
      }, {
        value: 8,
        label: 'Ib'
      }, {
        value: 9,
        label: 'Ic'
      }, {
        value: 10,
        label: 'In'
      }],
      posSelectValue: 1,
      showFft: []
    }
  },
  watch: {
    posSelectValue (val) {
      this.setValue(val)
    }
  },
  mounted () {
    this.setValue(this.posSelectValue)
  },
  methods: {
    setValue (val) {
      if (val === 1) {
        this.showFft = this.stableData ? this.stableData.fft_ua : []
      } else if (val === 2) {
        this.showFft = this.stableData ? this.stableData.fft_ub : []
      } else if (val === 3) {
        this.showFft = this.stableData ? this.stableData.fft_uc : []
      } else if (val === 4) {
        this.showFft = this.stableData ? this.stableData.fft_uab : []
      } else if (val === 5) {
        this.showFft = this.stableData ? this.stableData.fft_ubc : []
      } else if (val === 6) {
        this.showFft = this.stableData ? this.stableData.fft_uca : []
      } else if (val === 7) {
        this.showFft = this.stableData ? this.stableData.fft_ia : []
      } else if (val === 8) {
        this.showFft = this.stableData ? this.stableData.fft_ib : []
      } else if (val === 9) {
        this.showFft = this.stableData ? this.stableData.fft_ic : []
      } else if (val === 10) {
        this.showFft = this.stableData ? this.stableData.fft_in : []
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">谐波频谱表</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px">
        <div style="display: flex; width: 100%;">
          <div
            style="display: flex; align-items: center; margin-left: 20px">
            <div style="width: 80px; text-align: left">电气量</div>
            <div style="width: 120px; margin-left: 10px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 100px);">
        <div class="dataItem" style="height: 100%; border-top: 1px solid black">
          <div class="dataName">
            <div class="dataTitle">次数</div>
            <div class="dataNvItem">1</div>
            <div class="dataNvItem">2</div>
            <div class="dataNvItem">3</div>
            <div class="dataNvItem">4</div>
            <div class="dataNvItem">5</div>
            <div class="dataNvItem">6</div>
            <div class="dataNvItem">7</div>
            <div class="dataNvItem">8</div>
            <div class="dataNvItem">9</div>
            <div class="dataNvItem">10</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[0]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[1]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[2]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[3]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[4]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[5]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[6]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[7]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[8]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[9]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">次数</div>
            <div class="dataNvItem">11</div>
            <div class="dataNvItem">12</div>
            <div class="dataNvItem">13</div>
            <div class="dataNvItem">14</div>
            <div class="dataNvItem">15</div>
            <div class="dataNvItem">16</div>
            <div class="dataNvItem">17</div>
            <div class="dataNvItem">18</div>
            <div class="dataNvItem">19</div>
            <div class="dataNvItem">20</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[10]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[11]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[12]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[13]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[14]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[15]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[16]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[17]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[18]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[19]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">次数</div>
            <div class="dataNvItem">21</div>
            <div class="dataNvItem">22</div>
            <div class="dataNvItem">23</div>
            <div class="dataNvItem">24</div>
            <div class="dataNvItem">25</div>
            <div class="dataNvItem">26</div>
            <div class="dataNvItem">27</div>
            <div class="dataNvItem">28</div>
            <div class="dataNvItem">29</div>
            <div class="dataNvItem">30</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[20]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[21]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[22]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[23]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[24]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[25]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[26]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[27]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[28]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[29]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">次数</div>
            <div class="dataNvItem">31</div>
            <div class="dataNvItem">32</div>
            <div class="dataNvItem">33</div>
            <div class="dataNvItem">34</div>
            <div class="dataNvItem">35</div>
            <div class="dataNvItem">36</div>
            <div class="dataNvItem">37</div>
            <div class="dataNvItem">38</div>
            <div class="dataNvItem">39</div>
            <div class="dataNvItem">40</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[30]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[31]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[32]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[33]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[34]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[35]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[36]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[37]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[38]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[39]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">次数</div>
            <div class="dataNvItem">41</div>
            <div class="dataNvItem">42</div>
            <div class="dataNvItem">43</div>
            <div class="dataNvItem">44</div>
            <div class="dataNvItem">45</div>
            <div class="dataNvItem">46</div>
            <div class="dataNvItem">47</div>
            <div class="dataNvItem">48</div>
            <div class="dataNvItem">49</div>
            <div class="dataNvItem">50</div>
          </div>
          <div class="dataValue">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[40]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[41]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[42]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[43]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[44]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[45]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[46]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[47]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[48]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[49]).toFixed(1) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataName {
  width: 8%;
}

.dataValue {
  width: 12%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 50px) / 10);
}

</style>



// WEBPACK FOOTER //
// src/pages/Stable/ThdTable/ThdTable.vue